import { httpClient } from '../transports/http.js'

export async function registerDevice({ token }) {
  return (await httpClient.post('api/REGDEVICE', { appid: '_MASTERFIX', appver: '0.9', deviceid: token, prevdeviceid: '', mobileos: 'ANDROID' })).data
}

export async function unRegisterDevice({ token }) {
  return (await httpClient.post('api/UNREGUSER', { appid: '_MASTERFIX', deviceid: token })).data
}